
import { ref, computed } from "vue";
import { useStore } from 'vuex';
import GameService from "../../../services/GameService";
import TokenService from "../../../services/TokenService";
import ResponseData from "@/_models/ResponseData";
import { Helper } from "@/utils/Helper";
import store from "@/store/index";
import { useRouter, useRoute } from "vue-router";
import { TokenUtils } from "@/utils/TokenUtils";
export default{
  name: 'tokensLinkedGamesComponent',
  props: {
    publicKey: String,
    network: String,
    tokenId: String,
  },
  components: {

  },
  data: function () {
    return {
      userData: store.getters["auth/user"] ?? "",
      jwtToken: store.getters["auth/jwtToken"] ?? "",
      isDisplayChooseGameModal: false,
      checkAttachedGames: false,
      selectAttachedGame: "",
      selectedGame: null,
      attachedGames: [],
      games: [],
      
    };
  },
  methods: {
    getGamesList() {
      if (this.userData !== "") {
        GameService.getGameListByWalletAddress(this.network=='testnet'?this.userData.testnetWalletAddress:this.userData.mainnetWalletAddress, this.network)
          .then((response: ResponseData) => {
            this.games = response.data;
          })
          .catch((error) => {
            Helper.endpointErrorHandling(error);
          });
      }
    },

    getAttachedGames() {
      if (this.tokenId !== undefined) {
        TokenService.getGamesAttachedToToken(this.tokenId, this.network)
          .then((response: ResponseData) => {
            this.attachedGames = response.data.viewModel;
            if (this.attachedGames) {
              this.checkAttachedGames = true;
            }
          })
          .catch((error) => {
            Helper.endpointErrorHandling(error);
          })
      }
    },

    selectAttachedGameFunc(name: string) {
      console.log(name)
      this.selectAttachedGame = name;
      this.selectedGame = name;
    },

    saveAttachedGame() {
      if (this.tokenId !== undefined && this.userData !== '' && this.jwtToken !== '') {
        TokenService.attachTokensToGame(this.tokenId, this.selectAttachedGame, this.userData.userId, this.jwtToken, this.network)
          .then(() => {
            this.getAttachedGames();
            this.isDisplayChooseGameModal = false;
          })
          .catch((error) => {
            Helper.endpointErrorHandling(error);
          })
      }
    },
  },
  computed: {
    testnetLabel() {
      return store.getters['config/configTestnetLabel'];
    },
    mainnetLabel() {
      return store.getters['config/configMainnetLabel'];
    },
    assetUrl() {
      return store.getters['config/assetUrl'];
    },
    testnetTokenId(){
      return this.$route.params.testnetTokenId;
    },
    networkLabel(){
      return Helper.capitalizeFirstLetter(this.network);
    }
  },
  mounted() {
    this.getGamesList();
    this.getAttachedGames();
  },
}
